module.exports = __webpack_public_path__ + "img/logo.a8a709d5.png";